<x-chartist [data]="animationData" [type]="'Line'" [options]="animationOptions" class="height-300 chartist-animated">
</x-chartist>